const routes = []
const context = require.context('./', true, /^\.\/(?!index).*?\.js$/)

context.keys().forEach(key => {
  routes.push(...context(key).default)
})

export default routes
